import React from "react";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiFillStar,
  AiFillLinkedin,
} from "react-icons/ai";
import { FiFileText , FiUser} from "react-icons/fi";
import { HiOutlineMail } from "react-icons/hi";
import { DiGitBranch } from "react-icons/di";

import { Link } from "react-router-dom";
function MobileNav({ showNav, setShowNav }) {
  return (
    <div
      className={
        showNav
          ? "fixed h-1/2 bg-gradient-to-r from-purple-900 to-violet-900  w-full top-[68px] left-0 rounded-b-md border-2 border-t-0 border-purple-700 z-50 transition-all duration-[500ms] overflow-hidden"
          : "fixed h-0 bg-gradient-to-r from-purple-900 to-violet-900  w-full top-[68px] left-0 rounded-b-md  z-50 transition-all duration-[500ms] overflow-hidden"
      }
    >
      <div className=" block items-center justify-center text-white">
        <ul className="flex gap-8 flex-col mt-10">
          <li className="relative group">
            <Link
              to={"/"}
              className="flex gap-1 items-center justify-center cursor-pointer text-base font-bold relative"
              onClick={() => setShowNav(false)}
            >
              <AiOutlineHome fontSize={20} />
              <span className="">Home</span>
            </Link>
          </li>
          {/* <li className="relative group">
            <Link
              to={"/about"}
              className="flex gap-1 items-center justify-center cursor-pointer text-base font-bold relative"
              onClick={() => setShowNav(false)}
            >
              <FiUser fontSize={20} />
              <span className="">About</span>
            </Link>
          </li> */}
          <li className="relative group">
            <Link
              to={"/projects"}
              className="flex gap-1 items-center justify-center cursor-pointer text-base font-bold relative"
              onClick={() => setShowNav(false)}
            >
              <AiOutlineFundProjectionScreen fontSize={20} />
              <span className="">Projects</span>
            </Link>
          </li>
          <li className="relative group">
            <Link
              to={"/resume"}
              className="flex gap-1 items-center justify-center cursor-pointer text-base font-bold relative"
              onClick={() => setShowNav(false)}
            >
              <FiFileText fontSize={20} />
              <span className="">Resume</span>
            </Link>
          </li>
        </ul>

        <a
          href="https://github.com/Upadhyay-Yatendra"
          target="_blank"
          rel="noreferrer"
          className="flex  w-24 my-5 mx-auto gap-2 justify-center items-center text-lg bg-fuchsia-900 px-3 py-[3px] border border-purple-700 rounded-sm"
        >
          <DiGitBranch fontSize={18} />
          <AiFillStar fontSize={18} />
        </a>
        <a
          href="https://www.linkedin.com/in/yatendra-upadhyay/"
          target="_blank"
          rel="noreferrer"
          className="flex  w-24 my-5 mx-auto gap-2 justify-center items-center text-lg bg-fuchsia-900 px-3 py-[3px] border border-purple-700 rounded-sm"
          title="LinkedIn"
        >
          <AiFillLinkedin fontSize={24} />
        </a>
        <a
          href="mailto:yupadhyayyk@gmail.com"
          className="flex  w-24 my-5 mx-auto gap-2 justify-center items-center text-lg bg-fuchsia-900 px-3 py-[3px] border border-purple-700 rounded-sm"
          title="Email"
        >
          <HiOutlineMail fontSize={24} />
        </a>
      </div>
    </div>
  );
}

export default MobileNav;
